module.exports = __webpack_public_path__ + "static/media/img_offer_alarms@2x.7a71ab84.png";